// Determine the base URL based on the environment
const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3000' // RUST dev server URL
  : ''; // Empty string for production to use relative paths

console.log("API_BASE_URL: ", API_BASE_URL)

export const API_ENDPOINTS = {
    calculate_revenue: `${API_BASE_URL}/api/heating/calculate-revenue`
};
